import GLightbox from 'glightbox';

/**
 * Initialize GLightbox for gallery images and other lightbox elements
 */
export function initGalleryLightbox() {
  const lightbox = GLightbox({
    selector: '.glightbox',
    loop: true
  });

  return lightbox;
}

/**
 * Handle gallery blocks specifically - create links for images without them
 */
export function setupGalleryBlocks() {
  const galleryBlocks = document.querySelectorAll('.wp-block-gallery');

  galleryBlocks.forEach((gallery, galleryIndex) => {
    const images = gallery.querySelectorAll('img');

    images.forEach((img, index) => {
      let link = img.closest('a');

      // If no link exists, create one
      if (!link) {
        link = document.createElement('a');
        link.href = img.src;
        link.classList.add('glightbox');
        link.setAttribute('data-glightbox', `gallery-${galleryIndex}`);

        // Add alt text as description if available
        if (img.alt) {
          link.setAttribute('data-description', img.alt);
        }

        // Wrap the image with the link
        img.parentNode.insertBefore(link, img);
        link.appendChild(img);
      } else {
        // If link exists, add glightbox class
        link.classList.add('glightbox');
        link.setAttribute('data-glightbox', `gallery-${galleryIndex}`);

        // Add alt text as description if available
        if (img.alt) {
          link.setAttribute('data-description', img.alt);
        }
      }

      // Add cursor pointer style to make it clear it's clickable
      img.style.cursor = 'pointer';
    });
  });
}

/**
 * Handle individual images with glightbox class
 */
export function setupIndividualImages() {
  const lightboxImages = document.querySelectorAll('img[class*="glightbox"], a[class*="glightbox"]');

  lightboxImages.forEach(element => {
    if (!element.classList.contains('glightbox')) {
      element.classList.add('glightbox');
    }
  });
}

/**
 * Initialize all gallery functionality
 */
export function initGallery() {
  // Setup gallery blocks first
  setupGalleryBlocks();

  // Setup individual images
  setupIndividualImages();

  // Initialize GLightbox
  const lightbox = initGalleryLightbox();

  return lightbox;
}
